<svelte:options accessors={true}/>
<script>
    import Search from './sorting/Search.svelte';
    import EntriesSelector from './sorting/EntriesSelector.svelte';
    import { createEventDispatcher } from 'svelte';
    import CellsMenu from './CellsMenu.svelte';
    import AuthService from '../services/auth.service.js';

    export let component, talentTrackingFilters = 0;
    export let params = null;
    export let roles = [];

    const ableTo = {
        export: ['Weekly', 'Monthly', 'Employees', 'Sdr', 'StaffingDashboard', 'Candidates', 'Census', 'Plans', 'Staff', 'TalentTracking'],
        add_section: ['Weekly', 'Monthly', 'Employees'],
        add_row: ['Candidates', 'Census', 'Staff', 'TalentTracking'],
        remove_indicator: ['Weekly', 'Monthly', 'Sdr'],
        import: ['Candidates', 'Census', 'Plans', 'Staff', 'TalentTracking'],
        show_entries: ['Candidates', 'Census', 'Staff', 'TalentTracking']
    };

    const exportAllPortcosExceptions = ['activity'];
    const removeIndicatorExceptions = ['activity'];

    const dispatch = createEventDispatcher();

    let selectedActivity = 'employee';
    let roleFilter = null;
    let loadingExport = false;

    function setRoleFilter(role) {
        roleFilter = role;
        dispatch('roleFilter', {role: role});
    }

    let exportReport = function(allPortcos = false) {
        loadingExport = true;
        const verifyExport = setInterval(() => {
            if(component && !component.loadingExport){
                loadingExport = false;
                clearInterval(verifyExport);
            }
        }, 100);
        dispatch('exportReport', {all_portcos: allPortcos});
    }
    function changeExportStatus(){
        console.log(component);
    }
    let indicatorsRemoved = function(response) {
        dispatch('indicatorsRemoved', true);
    }

    let addEmployee = function(response) {
        dispatch('addEmployee', true);
    }

    let addSection = function(response) {
        dispatch('addSection', true);
    }

    // HR
    let importModal = function(response) {
        dispatch('importModal', true);
    }

    let addRow = function(response) {
        dispatch('addRow', true);
    }

    let selectEntries = function(entries) {
        dispatch('selectEntries', {entries: entries});
    }

    let search = function(searchText) {
        dispatch('search', {search: (searchText || '').toLowerCase()});
    }

    const showFilters = () => {
        component.openFiltersModal();
    }

    const clearFilters = () => {
        component.clearFilters();
    }

    const addTalentTrackingCandidate = () => {
        component.addRow();
    }

    const selectActivity = (activity) => {
        selectedActivity = activity;
        dispatch('selectActivity', activity);
    }

    const allowedToAllPortcosExport = ['Employees'];

    // Reset role filter (all roles) when org is changed for activity component
    $: if (params && params.org && component && component.constructor.name === 'Employees' && params.subMenu === 'activity') {
        setRoleFilter(null);
    }
</script>
<div class="row mb-2">
    {#if component && ableTo.show_entries.includes(component.constructor.name)}
        <EntriesSelector entries={component.entries} on:change={(e) => selectEntries(e.detail.entries)} class="pl-2" />
        <Search on:change={(e) => search(e.detail.search)} />
        {#if component.constructor.name === 'TalentTracking'}
            <div class="col-md-3"> </div>
        {/if}
    {/if}
    <div class="pr-3 {(component && component.constructor.name == 'Weekly')? 'text-center ' : ''} {component && ableTo.show_entries.includes(component.constructor.name) ? `text-right col-4 ${component && component.constructor.name === 'TalentTracking' ? '' : 'offset-3'}` : 'col-12'}">
        {#if component && component.constructor.name == 'Weekly'}
            <h5 id="week-ending-text">Week Ending</h5>
        {/if}
        <div class="float-right">
            {#if params.subMenu === 'activity'}
                <div class="btn-group">
                    <button on:click={() => selectActivity('employee')}
                            class="btn btn-sm employee btn-{selectedActivity !== 'metrics' ? 'primary' : 'secondary'}"
                            title="By Employee"><i class="fa fa-user"></i></button>
                    <button on:click={() => selectActivity('metrics')}
                            class="btn btn-sm metrics btn-{selectedActivity === 'metrics' ? 'primary' : 'secondary'}"
                            title="By Metrics"><i class="fa fa-newspaper-o"></i></button>
                </div>
                <button on:click={addEmployee} class="btn btn-sm btn-primary ml-2 ">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add Employee
                </button>
            {:else}
                {#if AuthService.can('EDIT_SECTION') && component && ableTo.add_section.includes(component.constructor.name)}
                    <button on:click={addSection} class="btn btn-sm btn-primary ml-2 ">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Add Section
                    </button>
                {/if}
            {/if}

            {#if component && ableTo.remove_indicator.includes(component.constructor.name) || removeIndicatorExceptions.includes(params.subMenu) }
                <CellsMenu on:indicatorsRemoved={indicatorsRemoved} params={params}></CellsMenu>
            {/if}
            <!-- HR -->
            {#if component && ableTo.add_row.includes(component.constructor.name)}
                {#if AuthService.can('ADD_CANDIDATE') && component && component.constructor.name !== 'TalentTracking' }
                    <button class="btn btn-primary btn-sm text-light"
                            on:click={addRow}>
                        <i class="fa fa-plus"></i>
                        Add
                        {#if component && component.constructor.name == 'Candidates'}
                            Candidate
                        {:else if  component && component.constructor.name == 'Census'}
                            <!-- Termination Census -->
                            Position
                        {:else if  component && component.constructor.name == 'Staff'}
                            <!-- Open Positions report-->
                            Open Position
                        {/if}
                    </button>
                {/if}

                {#if (AuthService.canShow('talent_tracking_tab') || AuthService.can('MAKE_EXTERNAL_TALENT_TRACKING_CHANGES')) && component && component.constructor.name === 'TalentTracking'}
                    <a href="https://s3.us-west-2.amazonaws.com/new-riverside-kpis.seagage.com/Talent+Tracking+User+Guide.pdf" target="_blank" class="btn btn-primary btn-sm text-light">
                        <i class="fa fa-book mr-1"></i>
                        User Guide
                    </a>
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button class="btn btn-primary btn-sm text-light"
                                on:click={showFilters}>
                            <i class="fa fa-filter"></i>
                            Filters
                        </button>
                        {#if talentTrackingFilters > 0}
                            <button class="btn btn-primary btn-sm text-light" on:click={clearFilters}>
                      <span class="badge bg-primary text-light">
                        {talentTrackingFilters}
                      </span>
                                &nbsp;&times;
                            </button>
                        {/if}

                    </div>
                {/if}
                {#if AuthService.can('ADD_CANDIDATE') && component && component.constructor.name === 'TalentTracking'}
                    <button class="btn btn-primary btn-sm text-light"
                            on:click={addTalentTrackingCandidate}>
                        <i class="fa fa-plus"></i>
                        Add Candidate
                    </button>
                {/if}
            {/if}
            {#if component && ableTo.export.includes(component.constructor.name)}
                {#if allowedToAllPortcosExport.includes(component.constructor.name) && AuthService.can('EXPORT_HR_ALL_PORTCOS') && !exportAllPortcosExceptions.includes(params.subMenu)}
                    <div class="dropdown float-right mr-2">
                        <button class="btn btn-sm btn-primary ml-2" disabled={loadingExport}>
                            <i class={loadingExport? 'fa fa-circle-o-notch fa-spin':'fa fa-file-excel-o'} aria-hidden="true"></i>
                            Export
                        </button>

                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li on:click={() => exportReport(false)} class="dropdown-item">
                                Selected Company
                            </li>
                            <li on:click={() => exportReport(true)} class="dropdown-item">
                                All Companies
                            </li>
                        </ul>
                    </div>
                {:else}
                    <button id="export-btn" on:click={() => exportReport(false)} class="btn btn-sm btn-primary ml-2 " disabled={loadingExport}>
                        <i class={loadingExport? 'fa fa-circle-o-notch fa-spin':'fa fa-file-excel-o'} aria-hidden="true"></i>
                        Export
                    </button>
                {/if}
            {/if}
            {#if component && ableTo.import.includes(component.constructor.name)}
                {#if (component.constructor.name !== 'TalentTracking' && AuthService.can('IMPORT_HR_REPORTS')) ||
                (component.constructor.name === 'TalentTracking' && (AuthService.canShow('talent_tracking') || AuthService.can('MAKE_EXTERNAL_TALENT_TRACKING_CHANGES')))}
                    <button class="btn btn-success btn-sm text-light {(component && component.constructor.name == 'Plans')? 'float-right' : ''}"
                            on:click={importModal}>
                        <i class="fa fa-upload"></i>
                        Import
                    </button>
                {/if}
            {/if}
        </div>
        {#if params.subMenu === 'activity'}
            <Search className="d-inline-block" on:change={(e) => search(e.detail.search)}
                    placeholder="Search by {selectedActivity === 'employee'? 'Name': 'Metric'}..." />
            <div class="d-inline-block dropdown mr-2">
                <button class="form-control text-left ml-2 dropdown-toggle">
                    {roleFilter ? roleFilter.title : 'All Roles'}
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li on:click={() => setRoleFilter(null)} class="dropdown-item">
                        All Roles
                    </li>
                    {#each roles as role}
                        <li on:click={() => setRoleFilter(role)} class="dropdown-item">
                            {role.title}
                        </li>
                    {/each}
                </ul>
            </div>
        {/if}
    </div>
</div>
